var map = {
	"./abdomen.png": 82386,
	"./ankle.png": 5817,
	"./arm.png": 90234,
	"./behind-leg.png": 83792,
	"./calf.png": 19818,
	"./chest.png": 10009,
	"./finger.png": 11725,
	"./head.png": 67509,
	"./hip.png": 39725,
	"./joint.png": 69024,
	"./knee.png": 77582,
	"./lower-back.png": 71387,
	"./shin.png": 80385,
	"./shoulder-2.png": 96326,
	"./shoulder.png": 50178,
	"./thigh.png": 1659,
	"./toenail.png": 64946,
	"./upper-back.png": 21705,
	"./waist.png": 73018,
	"./wrist.png": 49014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60563;